module.exports = __webpack_public_path__ + "static/media/strokewidth.17b29d3a.svg";